import { render, staticRenderFns } from "./IdentifyJobForm.vue?vue&type=template&id=47785812&scoped=true"
import script from "./IdentifyJobForm.vue?vue&type=script&lang=js"
export * from "./IdentifyJobForm.vue?vue&type=script&lang=js"
import style0 from "./IdentifyJobForm.vue?vue&type=style&index=0&id=47785812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47785812",
  null
  
)

export default component.exports